import { ApiService } from "@/api";
import { keysLower } from "@/core/helpers";

export default {
  GET_TIMELINE({ commit }, id_camera) {
    return ApiService.cameras
      .getTimelinesArchive(id_camera)
      .then((data) => commit("SET_TIMELINE", data.timelines));
  },
  GET_TIMELINE_HISTORY({ commit }, id_camera) {
    return ApiService.cameras
      .getServersHistory(id_camera)
      .then((data) => commit("SET_TIMELINE_HISTORY", data))
  },
  GET_MOTIONS({ commit }, id_camera) {
    return ApiService.cameras
      .getTimelinesMotion(id_camera)
      .then((data) => commit("SET_MOTIONS", data.motions));
  },
};
